import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMacbook: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="macbook, laptop, computer"><path d="M22.25 17C22.6642 17 23 17.3358 23 17.75V18.25C23 19.7688 21.7688 21 20.25 21H3.75C2.23122 21 1 19.7688 1 18.25V17.75C1 17.3358 1.33579 17 1.75 17H22.25Z" fill="currentColor"/><path d="M17.75 3C19.5449 3 21 4.45507 21 6.25V15.5H3V6.25C3 4.45507 4.45507 3 6.25 3H17.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMacbook;
